export default "__VITE_ASSET__HM3DHo_8__"